import React, { useEffect, useState } from 'react'
import { redirect, useNavigate, useParams } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import { Button, Fab, Grid, Typography } from '@mui/material';

export const SubHeader = ({ titulo }) => {
    const Navigate = useNavigate();


    const goBack = () => {
        window.history.back();
    }

    return (
        <Grid
            container
            direction="row"
                size={{ xs: 12 }}
                sx={{ justifyContent: "center", alignItems: "center" }}>
            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{ justifyContent: "space-between", alignItems: "center" }}>
                <Fab className='returnButton' variant="contained" size='medium' color="primary" onClick={() => goBack()}>
                    <ArrowBackIcon fontSize="medium" />
                </Fab>

                <Typography variant='h4' sx={{
                    fontSize: {
                        xs: 16, sm: 25, md: 30, lg: 35, xl: 40
                    }
                }}>
                    {titulo}
                </Typography>

                <Fab className='returnButton' variant="contained" size='medium' color="primary" onClick={() => Navigate("/")}>
                    <HomeIcon fontSize="medium" />
                </Fab>
            </Grid>
        </Grid>

    )
}
